import { useEffect, useRef, useState } from "react";
import { Loader2, Send } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

// Thread messaggi studio <-> professionista. `mine` = valore di `da` che va allineato a destra.
export const ProMessaggi = ({ messaggi, mine, onSend, testId = "pro-msg", light = false }) => {
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const boxRef = useRef(null);
  useEffect(() => { if (boxRef.current) { boxRef.current.scrollTop = boxRef.current.scrollHeight; } }, [messaggi.length]);
  const send = async () => {
    if (!txt.trim()) return;
    setBusy(true);
    try { await onSend(txt.trim()); setTxt(""); } finally { setBusy(false); }
  };
  const box = light ? "bg-white border-slate-200" : "bg-slate-900/40 border-slate-700";
  return (
    <div className="space-y-2" data-testid={testId}>
      <div ref={boxRef} className={`max-h-72 overflow-y-auto rounded-lg border p-3 space-y-2 ${box}`}>
        {messaggi.length === 0 && <p className="text-xs text-slate-500">Nessun messaggio.</p>}
        {messaggi.map((m) => (
          <div key={m.id} className={`flex ${m.da === mine ? "justify-end" : "justify-start"}`}>
            <div className="max-w-[80%] rounded-lg px-3 py-2 text-sm whitespace-pre-wrap" data-testid={`${testId}-item`}
              style={m.da === mine ? { background: "#f59e0b", color: "#0f172a" } : { background: "#e2e8f0", color: "#0f172a" }}>
              {m.testo}
              <div className="mt-1 text-[10px] opacity-70">{m.autore} · {fmt(m.created_at)}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <textarea value={txt} onChange={(e) => setTxt(e.target.value)} rows={2} placeholder="Scrivi un messaggio…" data-testid={`${testId}-input`}
          className={`flex-1 rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-amber-500 ${light ? "bg-white border-slate-300 text-slate-900" : "bg-slate-900/60 border-slate-700 text-slate-100"}`} />
        <button type="button" onClick={send} disabled={busy || !txt.trim()} data-testid={`${testId}-send`} className="self-end h-10 px-4 rounded-md bg-amber-500 hover:bg-amber-600 text-slate-950 font-semibold disabled:opacity-50 inline-flex items-center gap-1">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Invia
        </button>
      </div>
    </div>
  );
};
